var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#8cc3d5;}.b{fill:#8cc3d5;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.465)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-0.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 22,
    cy: 22,
    r: 21.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.438,14.4A4.793,4.793,0,0,1,19,10.048a5.516,5.516,0,0,0-4.348-2.29c-1.823-.144-3.815,1.063-4.544,1.063-.77,0-2.536-1.011-3.922-1.011C3.326,7.856.281,10.095.281,14.648a12.8,12.8,0,0,0,.739,4.169c.657,1.884,3.029,6.5,5.5,6.428,1.294-.031,2.208-.919,3.892-.919,1.633,0,2.48.919,3.922.919,2.5-.036,4.641-4.235,5.267-6.125A5.089,5.089,0,0,1,16.438,14.4Zm-2.906-8.43A4.835,4.835,0,0,0,14.764,2.25a5.444,5.444,0,0,0-3.486,1.792A4.911,4.911,0,0,0,9.964,7.733a4.312,4.312,0,0,0,3.568-1.761Z",
    transform: "translate(12.441 6.792)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.16e74f3c.svg";
export { ForwardRef as ReactComponent };